  $(function() {
      window.onscroll = function() {
    	fix_filters()
    };
    
    var toolbar = document.getElementById("toolbar-mode");
    var content = document.getElementById("main-content");
    var sticky = toolbar.offsetTop;
    
    function fix_filters() {
    	if (window.innerWidth < 601 && window.pageYOffset > sticky) {
    		toolbar.classList.add("sticky");
    		content.classList.add("sticky");
    	} else {
    		toolbar.classList.remove("sticky");
    		content.classList.remove("sticky");
    	}
    }

    $("#filter-sidebar").scroll(function() {
    	if ($(window).width() < 991) {
    		var scroll = $("#filter-sidebar").scrollTop();
    		if (scroll > 30) {
    			$(".continue-filter").addClass("fillter-ticky");
    		} else {
    			$(".continue-filter").removeClass("fillter-ticky");
    		}
    	}
    });
  
	$('.hidden-sidebar  #filter-sidebar').hide();
	$('.hidden-sidebar .filter-collection-left > a').click(function() {
		$('.toolbar').toggleClass('active');
		$('#filter-sidebar').toggle(400);
	});
  
	$('.close-sibade').on('click', function() {
		$('.wrapper-container').removeClass('show-fillter');
		$('.toolbar').removeClass('active');
		$('body,html').css("overflow", "visible");
		$('body').removeClass('show-filter');
	});
  
	$('.show-results').on('click', function() {
		$('.close-sibade').click();
	});

	$('.filter-collection-left > a').click(function() {
		$('.toolbar').toggleClass('active');
		if ($('.wrapper-container').hasClass('show-fillter')) {
			$('.wrapper-container').removeClass('show-fillter');
			$('body,html').css("overflow", "visible");
			$('body').removeClass('show-filter');
		} else {
			$('.wrapper-container').addClass('show-fillter');
			$('body,html').css("overflow", "hidden");
			$('body').addClass('show-filter');
		}
	});
  
	$('.nm-page-overlay').click(function() {
		$('body,html').css("overflow", "visible");
		if ($('.wrapper-container').hasClass('show-fillter')) {
			$('.wrapper-container').removeClass('show-fillter');
			$('.toolbar').removeClass('active');
			$('body').removeClass('show-filter');
		}
	});

	$('body.template-collection .collection-view a').on('click', function() {
		$('.collection-view.active').removeClass('active');
		$(this).parent().addClass('active');

	});

	$('#list_view_mode').on('click', function() {
		$('.products-grid').addClass('product-list-item').removeClass('product-grid-item');
		lsStorage.cookie('mobileview', 'list', {
			expires: 365,
			path: '/'
		});
		return false;
	});

	$('#grid_view_mode').on('click', function() {
		$('.products-grid').addClass('product-grid-item').removeClass('product-list-item');
		lsStorage.cookie('mobileview', 'grid', {
			expires: 365,
			path: '/'
		});
		return false;
	});

	var mobile_view_cookie = lsStorage.cookie('mobileview');

	if (mobile_view_cookie) {
		$('#' + mobile_view_cookie + '_view_mode').click();
	} else {
		$('#list_view_mode').parent().addClass('active');
	}

	$(document).on("click touchdown", ".icon-tools-buy", function() {
		$(this).not('.disable').parents('.product-content').addClass('active'); //.find('.quick-buy').addClass('loading');
		return false;
	});
	$(document).on("click touchdown", ".close-quick-buy", function() {
		$(this).parents('.product-content').removeClass('active');
		return false;
	});

	if (navigator.share) {
		function shareImage(image, title, url) {			
            fetch(image)
            .then(response => {
              var blob = response.blob();
              return blob;
            })
            .then((blob) => {
              var file = [new File([blob], 'featured.jpg', {type: "image/jpeg"})];

              var shareData = {
                  title: title,
                  url: url,
                  files: file
              };
              
              if (navigator.canShare && navigator.canShare(shareData)) {
                navigator.share(shareData);
              }
            })
            .catch((error) => {
              console.error('Error:', error);
            });
    	}
      
		$(document).on("click touchdown", ".icon-tools-share", function(e) {
            e.preventDefault();
          
			var datapick = $(this);
			var image = 'https:' + datapick.data('featured-image');
			var title = datapick.data('title');
			var url = datapick.data('url');
          
			shareImage(image, title, url);
		});
      
    }
    else {
      $('.icon-tools-share').hide();
	}
  });  